const services = {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  async validateCustomSignUp(formData: any) {
    if (!formData.acknowledgement) {
      return {
        acknowledgement: 'You must agree to the Terms and Conditions',
      };
    }
  },
};

console.log('services: ', services);
export { services };
